define('components/asset-player/views/assets/image',[
    'components/asset-player/models/media-file'
], function (MediaFile) {
    "use strict";

    return Mn.ItemView.extend({
        "render": function () {
            this.$el.each(_.bind(function (idx, elem) {
                var $elem = $(elem),
                    layout = $elem.data('layout') || 'embed';

                switch (layout) {
                    case 'background':
                        this.setBackgroundImage($elem);
                        break;

                    case 'embed':
                        this.embedImage($elem);
                        break;
                }

                $elem.trigger('asset:render');
            }, this));
        },

        "getMediaFileUrl": function ($elem) {
            var typeId = +$elem.data('type-id') || null,
                typeIds,
                defaultTypeIds,
                mediaFiles,
                mediaFileUrl;

            defaultTypeIds = [
                MediaFile.Type.LARGE_IMAGES,
                MediaFile.Type.GENERAL_IMAGES
            ];

            typeIds = typeId && [typeId] || defaultTypeIds;

            mediaFiles = this.model.get('mediaFiles').filter(_.bind(function (mediaFile) {
                return mediaFile.get('url') && typeIds.indexOf(mediaFile.get('typeId')) > -1;
            }, this));

            if (!mediaFiles.length) {
                return '';
            }

            mediaFileUrl = mediaFiles.length && mediaFiles[0].get('url') || '';

            return mediaFileUrl;
        },

        "setBackgroundImage": function ($elem) {
            $elem.css('background-image', 'url("' + this.getMediaFileUrl($elem) + '")');
        },

        "embedImage": function ($elem) {
            $elem.html('<img src="' + this.getMediaFileUrl($elem) + '" />');
        }
    });
});

